// extracted by mini-css-extract-plugin
export var authorDetails = "blogAuthor-module--authorDetails--e4f84";
export var authorImage = "blogAuthor-module--authorImage--0fdd6";
export var authorImageFrame = "blogAuthor-module--authorImageFrame--8ccf7";
export var authorName = "blogAuthor-module--authorName--21892";
export var dark = "blogAuthor-module--dark--51e6d";
export var klaviyoLogo = "blogAuthor-module--klaviyoLogo--8f77e";
export var noImage = "blogAuthor-module--noImage--496e0";
export var readTime = "blogAuthor-module--readTime--0e11d";
export var row = "blogAuthor-module--row--7f3d5";